import { AnyAction } from "redux";
import { FindById, Update } from "../../../actorTyes";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { CapacitiesTypesAdapter } from "../../../../adapter/capacitiesTypes-adapter";

export const FETCH_UPDATE_CAPACITIES_TYPE_REQUEST = 'FETCH_UPDATE_CAPACITIES_TYPE_REQUEST';
export const FETCH_UPDATE_CAPACITIES_TYPE_SUCCESS = 'FETCH_UPDATE_CAPACITIES_TYPE_SUCCESS';
export const FETCH_UPDATE_CAPACITIES_TYPE_FAILURE = 'FETCH_UPDATE_CAPACITIES_TYPE_FAILURE';
export const SET_UPDATE_CAPACITIES_TYPE = 'SET_UPDATE_CAPACITIES_TYPE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateCapacitiesTypeRequest = () => {
    return {
        type: FETCH_UPDATE_CAPACITIES_TYPE_REQUEST,
    };
};

const fetchUpdateCapacitiesTypeSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_CAPACITIES_TYPE_SUCCESS,
        payload: data
    };
};

const fetchUpdateCapacitiesTypeFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_CAPACITIES_TYPE_FAILURE,
        payload: error,
    };
};

export const setUpdateCapacitiesType = (data: any) => {
    return {
        type: SET_UPDATE_CAPACITIES_TYPE,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateCapacitiesTypeRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateCapacitiesTypeSuccess(
                Adapter.from(response.data).to((value) => new CapacitiesTypesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateCapacitiesTypeFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateCapacitiesTypeRequest());
        try {
            const response = await FindById(id);
            dispatch(setUpdateCapacitiesType(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateCapacitiesTypeFailure(error.message));
        }
    };
};
